import React from "react";
import "./../styles/Dashboard.css";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const activeTileStyles = {
  boxShadow: "rgb(258, 71, 11, 0.8) 0px 0px 10px 10px",
};
export const Dashboard = ({
  completedNo,
  pendingNo,
  inprogressNo,
  ...props
}) => {
  return (
    <>
      {/* <Box className="cardbundle"> */}
      <Box
        className="cardbundle"
        style={{ maxWidth: "2160px", paddingTop: "3rem", marginBottom: "3rem" }}
      >
        <Grid container>
          {
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={10}>
                <Grid item xl={1.5} lg={1.5} md={1.5} sm={6} xs={12}>
                  &nbsp;
                </Grid>
                <Grid item xl={3} lg={3} md={3} sm={6} xs={12}>
                  <Box
                    className="managerCard"
                    sx={{ cursor: "pointer", backgroundColor: "#F5F5F5" }}
                    onClick={props.handlePending}
                    style={props.activeStyle.pending ? activeTileStyles : {}}
                  >
                    <img src="img/pending.svg" width="50" height="70" />
                    <Typography variant="h5">
                      {/* {props.dashboardTasklist[0].Pending} */}
                      {pendingNo}
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{ color: "#FB4E0B", textTransform: "uppercase" }}
                    >
                      Pending
                    </Typography>
                  </Box>

                  {/* {props.activeStyle.pending ? (
                    <img
                      src="img/polygon.svg"
                      width="50"
                      height="70"
                      style={{
                        alignContent: "center",
                        width: "100%",
                        padding: 20,
                      }}
                    />
                  ) : (
                    ""
                  )} */}
                </Grid>

                <Grid item xl={3} lg={3} md={3} sm={6} xs={12}>
                  <Box
                    className="managerCard"
                    sx={{ cursor: "pointer", backgroundColor: "#F5F5F5" }}
                    onClick={props.handleInprogress}
                    style={props.activeStyle.inprogress ? activeTileStyles : {}}
                  >
                    <img src="img/progress.svg" width="50" height="70" />
                    <Typography variant="h5">
                      {/* {props.dashboardTasklist[0].InProgress}{" "} */}
                      {inprogressNo}
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{ color: "#FB4E0B", textTransform: "uppercase" }}
                    >
                      In-Progress
                    </Typography>
                  </Box>

                  {/* {props.activeStyle.inprogress ? (
                    <img
                      src="img/polygon.svg"
                      width="50"
                      height="70"
                      style={{
                        alignContent: "center",
                        width: "100%",
                        padding: 20,
                      }}
                    />
                  ) : (
                    ""
                  )} */}
                </Grid>
                <Grid item xl={3} lg={3} md={3} sm={6} xs={12}>
                  <Box
                    className="managerCard"
                    sx={{ cursor: "pointer", backgroundColor: "#F5F5F5" }}
                    onClick={props.handleCompleted}
                    style={props.activeStyle.completed ? activeTileStyles : {}}
                  >
                    <img src="img/completed.svg" width="50" height="70" />
                    <Typography variant="h5">
                      {/* {props.dashboardTasklist[0].Completed}{" "} */}
                      {completedNo}
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{ color: "#FB4E0B", textTransform: "uppercase" }}
                    >
                      Completed
                    </Typography>
                  </Box>
                  {/* {props.activeStyle.completed ? (
                    <img
                      src="img/polygon.svg"
                      width="50"
                      height="70"
                      style={{
                        alignContent: "center",
                        width: "100%",
                        padding: 20,
                      }}
                    />
                  ) : (
                    ""
                  )} */}
                </Grid>
              </Grid>
            </Grid>
          }
        </Grid>
      </Box>
    </>
  );
};
